import React from 'react';

import 'components/pages/finance/shared/FinanseTableMUI/CustomFooter/CustomFooter.scss';

export const CustomFooter = ({ count }) => {
  return <div className="Mui-invoice-table-footer">{count.toLocaleString('en-US')} Total event IDs</div>;
};
